<template>
  <div>
    <div class="pileDetail">
      <el-col :xs="24" :lg="8" :span="8">
        <el-image :src="image" />
      </el-col>
      <el-col :xs="24" :lg="16" :span="16">
        <div class="details">
          <div class="specifier">
            <h1>充电桩 3.5kw~14kw交流</h1>
            <h3>产品特征 Product Features</h3>
            <ul>
              <li>模块化设计，稳定可靠；配置灵活，维护方便</li>
              <li>实现后台监控、运营管理和远程升级</li>
              <li>多重安装方式、使用更方便，可壁挂和落地式安装</li>
              <li>采用智能控制器对充电桩进行监测、控制和保护</li>
              <li>具备运行状态监测、故障监测；充电计量计费、充电过程远程控制的功能</li>
            </ul>
          </div>
          <div class="application">
            <h3>应用领域 Application Area</h3>
            <span>适用于私家电动汽车，商业写字楼，城市综合体等</span>
          </div>
        </div>
      </el-col>
    </div>
    <el-divider></el-divider>
    <div class="table">
<!--      <el-table-->
<!--        :span-method="objectSpanMethod"-->
<!--        :data="tableData"-->
<!--        style="width: 95%">-->
<!--        <el-table-column-->
<!--          prop="type"-->
<!--          label="产品分类"-->
<!--          width="200px">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c30"-->
<!--          label="3.5kw"-->
<!--          width="200px">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c60"-->
<!--          width="200px"-->
<!--          label="3.5kw+3.5kw">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c90"-->
<!--          width="200px"-->
<!--          label="7kw">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c120"-->
<!--          width="200px"-->
<!--          label="7kw+7kw">-->
<!--        </el-table-column>-->
<!--      </el-table>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "Pile14kw",
  data(){
    return{
      image:require('../../../assets/images/production/pile/交流.png'),
      tableData: [
        {
          type: '交流输入电压',
          c30: 'AC220V±15%',
          c60: 'AC220V±15%',
          c90: 'AC220V±15%',
          c120: 'AC220V±15%'
        },
        {
          type: '交流接入方式',
          c30: '单相',
          c60: '单相',
          c90: '单相',
          c120: '单相'
        },
        {
          type: '交流输入频率',
          c30: '50Hz±5%',
          c60: '50Hz±5%',
          c90: '50Hz±5%',
          c120: '50Hz±5%'
        },
        {
          type: '最大输出功率',
          c30: '3.5kw',
          c60: '3.5kw+3.5kw',
          c90: '7kw',
          c120: '7kw+7kw'
        },
        {
          type: '额定输出电压',
          c30: '220V',
          c60: '220V',
          c90: '220V',
          c120: '220V'
        },
        {
          type: '额定输出电流',
          c30: '16A',
          c60: '16A+16A',
          c90: '32A',
          c120: '32A+32A'
        },
        {
          type: '整机尺寸',
          c30: '壁挂式：280*140*700；落地式：360*200*1550',
          c60: '壁挂式：280*140*700；落地式：360*200*1550',
          c90: '壁挂式：280*140*700；落地式：360*200*1550',
          c120: '壁挂式：280*140*700；落地式：360*200*1550',
        },
        {
          type: '防护等级',
          c30: 'IP55',
          c60: 'IP55',
          c90: 'IP55',
          c120: 'IP55',
        },
        {
          type: '工作温度',
          c30: '-20℃~+55℃',
          c60: '-20℃~+55℃',
          c90: '-20℃~+55℃',
          c120: '-20℃~+55℃',
        },
        {
          type: '安全防护',
          c30: '过压保护、欠压保护、过流保护、漏电保护、过温保护、防雷保护、短路保护',
          c60: '过压保护、欠压保护、过流保护、漏电保护、过温保护、防雷保护、短路保护',
          c90: '过压保护、欠压保护、过流保护、漏电保护、过温保护、防雷保护、短路保护',
          c120: '过压保护、欠压保护、过流保护、漏电保护、过温保护、防雷保护、短路保护',
        },
        {
          type: '通信接口',
          c30: 'RS485/以太网接口',
          c60: 'RS485/以太网接口',
          c90: 'RS485/以太网接口',
          c120: 'RS485/以太网接口',
        },
        {
          type: '管理控制',
          c30: '单机、联网',
          c60: '单机、联网',
          c90: '单机、联网',
          c120: '单机、联网',
        },
        {
          type: '三防',
          c30: '壳体采用金属材料，防潮湿、防烟雾、防霉变，耐非常高温',
          c60: '壳体采用金属材料，防潮湿、防烟雾、防霉变，耐非常高温',
          c90: '壳体采用金属材料，防潮湿、防烟雾、防霉变，耐非常高温',
          c120: '壳体采用金属材料，防潮湿、防烟雾、防霉变，耐非常高温',
        },
        {
          type: '充电接口',
          c30: '单充',
          c60: '双充',
          c90:'单充',
          c120:'双充'
        },
      ]
    }
  },
  methods:{
    objectSpanMethod({row,column,rowIndex,columnIndex}){
      //console.log(row,column,rowIndex,columnIndex)
    }
  }
}
</script>

<style lang="less" scoped>
.pileDetail{
  margin: 30px 50px;
  overflow: hidden;
  .el-image{
    float: left;
    max-height: 523.8px;
    max-width: 379.8px;
    padding: 20px 20px;
  }
  .details{
    float: left;
    margin: 20px 0;
    .specifier{
      width: 85%;
      ul{
        width: 80%;
        li{
          list-style: none;
          &:before{
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            background-color: #2c6bb6;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }
    }
    .application{
      float: left;
      width: 85%;
      span{
        padding-left: 5px;
      }
    }
  }
  h1{
    padding: 0 5px;
    color: #2c6cb6;
  }
  h3{
    padding: 0 5px;
    color: #2c6cb6;
  }
}
.table{
  margin: 30px 50px;
}
</style>
